import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as themes from './assets/theme/scheme.json';
import { BrowserRouter } from 'react-router-dom';
import { setToLS } from './utils/storage';

const Index=()=>{
  // set all theme data to browser local storage.
  setToLS('all-theme',themes.default);
  return(
    <>
      
        {/* adding Browser Router on App component */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      
    
    </>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>,
  document.getElementById('root')
);

